import { Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { ReportsComponent } from './reports/reports.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ProfileHomeComponent } from './profile-home/profile-home.component';
import { ProfileComponent } from './profile-home/profile/profile.component';
import { FacsComponent } from './facs/facs.component';
import { PropertiesComponent } from './properties/properties.component';
import { ToggleGuardGuard } from './core/guards/toggle-guard/toggle-guard.guard';
import { TeamManagementComponent } from './team-management/team-management.component';
import { ErrorTokenComponent } from './errors-pages/error-token/error-token.component';
import { ErrorServiceComponent } from './errors-pages/error-service/error-service.component';
import { NotfoundExeptionsComponent } from './notfound-exeptions/notfound-exeptions.component';
import { ProductsFiltersComponent } from './products/product-register/products-filters/products-filters.component';
import { DistributionServiceComponent } from './reports/components/distributionService/distribution-service.component';
import { DistributionBrokerComponent } from './reports/components/distributionBroker/distribution-broker.component';
import { ImpoundedLeadsComponent } from './reports/components/ImpoundedLeads/impounded-leads.component';
import { ProductsComponent } from './products/product-register/products.component';
import { CaptureComponent } from './products/product-register/capture/capture.component';
import { OtherInformationComponent } from './products/product-register/other-information/other-information.component';
import { ProductCharacteristicsComponent } from './products/product-register/product-characteristics/product-characteristics.component';
import { DescriptionComponent } from './products/product-register/description/description.component';
import { MediaComponent } from './products/product-register/media/media.component';
import { ProfessionalComponent } from './products/product-register/professional/professional.component';
import { ProductSheetComponent } from './products/product-sheet/product-sheet.component';
import { ProductReadyComponent } from './products/product-sheet/product-ready/product-ready.component';
import { BrokerCalendarComponent } from './broker-calendar/broker-calendar.component';
import { FacsTourComponent } from './facs/facs-tour/facs-tour.component';
import { CompanyConfigurationListComponent } from './company-configuration-list/company-configuration-list.component';
import { CompanyConfigurationComponent } from './company-configuration-list/company-configuration/company-configuration.component';
import { BrokerProfileComponent } from './profile/broker-profile/broker-profile.component';
import { RouteGuard } from '../app/core/guards/route-guard/route-guard.guard';
import { HelperCenterComponent } from './helper-center/helper-center.component';
import { UserPreferencesComponent } from './user-preferences/user-preferences.component';
import { AuthGuard } from './core/guards/auth-guard/auth-guard';
import { LeadCampaignComponent } from './lead-campaign/lead-campaign.component';
import { LeadHomeComponent } from './lead-campaign/lead-home/lead-home.component';
import { LeadCampaignListComponent } from './lead-campaign/lead-campaign-list/lead-campaign-list.component';
import { BrokerProfileGuard } from './core/guards/broker-profile-guard/broker-profile.guard';
import { DashboardQueueComponent } from './dashboard-queue/dashboard-queue.component';
import { DistributionByQueueComponent } from './dashboard-queue/pages/distribution-by-queue/distribution-by-queue.component';
import {LegacyLogoutComponent} from "./legacy-logout/logout/legacy-logout.component";
import { NotFoundPageComponent } from './shared/components/not-found/not-found-page.component';
import { DashboardReportsComponent } from './dashboard-reports/dashboard-reports.component';
import { FaqHomeComponent } from './lead-campaign/faq/faq-home/faq-home.component';

const PUBLIC_ROUTES = [
  {
    path: 'relatorios-gestao',
    component: DashboardReportsComponent
  },
  {
    path: 'relatorios-gestao/:id',
    component: DashboardReportsComponent
  },
  {
    path: 'preferencias-do-usuario',
    component: UserPreferencesComponent,
  },
  {
    path: 'perfil/:name',
    component: ProfileHomeComponent,
    children: [
      {
        path: '',
        redirectTo: 'perfil',
        pathMatch: 'prefix'
      },
      {
        path: 'perfil',
        component: ProfileComponent
      }
    ]
  },
  {
    path: 'associado/:name',
    component: BrokerProfileComponent,
    canActivate: [BrokerProfileGuard]
  },
  {
    path: 'erro',
    children: [
      {
        path: 'token',
        component: ErrorTokenComponent
      },
      {
        path: 'servico',
        component: ErrorServiceComponent
      }
    ],
  },
  {
    path: 'nao-encontrado',
    component: NotfoundExeptionsComponent
  },
  {
    path: 'painel-filas-de-atendimento/distribuicao-por-fila',
    component: DistributionByQueueComponent
  },
  {
    path: 'legacy-logout',
    component: LegacyLogoutComponent
  }
];

const SECURE_ROUTES = [
  { path: 'home', component: HomeComponent },
  { path: 'central-ajuda', component: HelperCenterComponent },
  {
    path: 'relatorios-de-distribuicao',
    component: ReportsComponent,
    canActivate: [ToggleGuardGuard],
    data: {
      toggle: 'feature_reports'
    },
    children: [
      {
        path: 'distribuicao-atendimento',
        component: DistributionServiceComponent
      },
      {
        path: 'distribuicao-corretor',
        component: DistributionBrokerComponent
      },
      {
        path: 'leads-represados',
        component: ImpoundedLeadsComponent
      }
    ]
  },
  { path: 'notificacao', component: NotificationsComponent },
  {
    path: 'painel-filas-de-atendimento',
    component: DashboardQueueComponent
  },
  {
    path: 'gerenciamento-de-equipe',
    component: TeamManagementComponent,
    canActivate: [ToggleGuardGuard],
    data: {
      toggle: 'feature_distribution'
    }
  },
  {
    path: 'produtos',
    component: PropertiesComponent,
  },
  { path: 'facs/:id', component: FacsComponent },
  { path: 'facs/:tempo', component: FacsComponent },
  { path: 'facs/:temperatura', component: FacsComponent },
  { path: 'facs/:favoritos', component: FacsComponent },
  { path: 'facs/:incorporador', component: FacsComponent },
  { path: 'facs', component: FacsComponent },
  { path: 'facs-tour', component: FacsTourComponent },
  {
    path: 'produtos/registro',
    component: ProductsComponent,
    children: [
      {
        path: '',
        component: CaptureComponent
      },
      {
        path: 'outras-informacoes',
        component: OtherInformationComponent
      },
      {
        path: 'caracteristicas',
        component: ProductCharacteristicsComponent
      },
      {
        path: 'descricao',
        component: DescriptionComponent
      },
      {
        path: 'midias',
        component: MediaComponent
      },
      {
        path: 'profissional',
        component: ProfessionalComponent
      }
    ]
  },
  {
    path: 'produtos/filtros',
    component: ProductsFiltersComponent,
    canActivate: [ToggleGuardGuard],
    data: {
      toggle: 'feature_distribution'
    },
  },
  {
    path: 'agenda',
    component: BrokerCalendarComponent,
    canActivate: [ToggleGuardGuard],
    data: {
      toggle: 'feature_calendar'
    }
  },
  {
    path: 'produtos/ficha/:sku',
    component: ProductSheetComponent,
    children: [
      {
        path: '',
        component: ProductReadyComponent
      }
    ],
    canActivate: [ToggleGuardGuard],
    data: {
      toggle: 'feature_product_sheet'
    }
  },
  {
    path: 'lista-de-empresas',
    component: CompanyConfigurationListComponent,
  },
  {
    path: 'lista-de-empresas/configuracao-de-empresa',
    component: CompanyConfigurationComponent,
  },
  {
    path: 'lopes-leads',
    component: LeadCampaignComponent,
    data: {
      toggle: 'feature_lopes_lead'
    },
    children: [
      {
        path: '',
        component: LeadHomeComponent
      },
      {
        path: 'lista',
        component: LeadCampaignListComponent,
      },
      {
        path: 'perguntas-frequentes',
        component: FaqHomeComponent
      }
    ]
  }
];

const PUBLIC_PAGES = [
  { path: 'nao-encontrado', component: NotFoundPageComponent }
];

export const APP_ROUTES: Routes = [
  { path: '', pathMatch: 'prefix', redirectTo: 'home' },
  { path: '', children: PUBLIC_ROUTES },
  {
    path: '',
    canActivate: [AuthGuard, RouteGuard],
    children: SECURE_ROUTES
  },
  { path: 'paginas', children: PUBLIC_PAGES },
  { path: '**', redirectTo: 'paginas/nao-encontrado' },
];
